export enum ColorsEnum {
  Blue = 'blue',
  Green = 'green',
  Orange = 'orange',
}
